import { Navigate, Outlet } from 'react-router';

import styles from './styles.module.css';
import PulseIcon from '@/assets/PulseIcon.svg';
import PulseLogo from '@/assets/PulseLogoGradient.svg';
import useIsSignedIn from '@/hooks/useIsSignedIn';

function AuthLayout() {
  const userIsSignedIn = useIsSignedIn();

  if (userIsSignedIn) return <Navigate replace to="/" />;

  return (
    <div className={styles.container}>
      <img src={PulseLogo} alt="logo" className={styles.logo} />
      <div className={styles.containerWrapper}>
        <div className={styles.iconContainer}>
          <img src={PulseIcon} alt="icon" className={styles.icon} />
          <p className={styles.iconText}>Pulse</p>
        </div>
        <div className={styles.formContainer}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
